import queryString from "query-string";

export default function getSearchParams() {
  return queryString.parse(document.location.search);
}
